'use strict';

angular.module('internal.inspections')
    .controller('InternalInspectionsChecklistForm', ['$scope', '$stateParams', '$q', 'FBForms', 'FBFormTypes', '$state', 'DataSets',
        function ($scope, $stateParams, $q, FBForms, FBFormTypes, $state, DataSets) {
        $scope.resetChecklist();
        $scope.form = $stateParams.form;
        $scope.masterForm = $stateParams.form;
        $scope.formID = $stateParams.formID;
        $scope.formType = {};
        $scope.saving = false;
        $scope.resetting = false;
        $scope.loading = true;
        $scope.parameters = { template_id: $stateParams.id };

        var promises = [];

        promises.push(FBFormTypes.getByCode('inspection_checklist').then(function (formType) {
            $scope.formType = formType;
            if ($stateParams.formID == null) {
                $scope.form = { name: 'New Form', form_type_id: formType.id, the_form: {}, pages: [{ id: guid(), name: 'Page 1', tab_active: true, sort_order: 0, sections: [{ id: guid(), name: 'Section 1', sort_order: 0, questions: [] }] }] };
                $scope.masterForm = angular.copy($scope.form);
            }            
        }));

        if ($stateParams.formID != null) {
            promises.push(FBForms.getByID($stateParams.formID).then(function (form) {
                if (form.pages.length > 0) {
                    form.pages[0].tab_active = true;
                }
                $scope.form = form;
                $scope.form.the_form = {};
                $scope.masterForm = angular.copy($scope.form);
            }));
        }

        $q.all(promises).then(function () {
            $scope.loading = false;
        }).catch(function (response) {
            // handle error
        });

        $scope.activePage = function () {
            for (var i = 0; i < $scope.form.pages.length; i++) {
                var page = $scope.form.pages[i];
                if (page.tab_active) {
                    return i;
                }
            }
            return 0;
        }

        $scope.save = function () {
            $scope.saving = true;
            $scope.oldActivePage = $scope.activePage();

            //Loop through each page
            $scope.form.pages.forEach(function (page) {
                if (page.sections != null && page.sections.length > 0) {
                    //Loop through each section
                    page.sections.forEach(function (section) {
                        if (section.components != null && section.components.length > 0) {
                            //Loop through each component 
                            section.components.forEach(function (component) {
                                if (component.questions != null && component.questions.length > 0) {
                                    //Save non-empty questions.
                                    component.questions = component.questions.filter(function (question) {
                                        return (question.id !== undefined);
                                    });
                                }
                            });
                            //Save non-empty components again on the way back out
                            section.components = section.components.filter(function (component) {
                                if (component.id != undefined) {
                                    return (((component.component_type.code == 'custom' || component.component_type.code == 'dataset') && component.questions.length > 0) || (component.component_type.code != 'custom' && component.component_type.code != 'dataset' && component.component_type.code != null));
                                }
                            });
                        }
                    });
                    //Save non-empty sections again on the way back out
                    page.sections = page.sections.filter(function (section) {
                        return (section.components.length > 0);
                    });
                }
            });

            FBForms.save({ form: $scope.form, template_id: $stateParams.id }).then(function (form) {
                if (form != null) {
                    $scope.form = form;
                    if ($scope.form.pages != null && $scope.form.pages.length > 0) {
                        $scope.form.pages[$scope.oldActivePage < $scope.form.pages.length ? $scope.oldActivePage : 0].tab_active = true;
                    }

                    $scope.masterForm = angular.copy($scope.form);
                    $scope.getTemplate();

                    if ($scope.formID == null) {
                        $state.go('internal.inspecting.resource.checklist.form', { formID: form.id, form: form });
                    }
                }

                $scope.saving = false;
            });
        }

        $scope.reset = function () {
            $scope.resetting = true;
            $scope.form = angular.copy($scope.masterForm);
            $scope.resetting = false;
        }

        $scope.$watch('$parent.checklist', function (checklist) {
            if (checklist) {
                if (checklist.inspection_type === 'vehicle') {
                    DataSets.getForInspection("774E4CE2-2D43-43FA-B64D-C70EB53E81EE").then(function (dataSets) { // vehicle data set id
                        $scope.dataSets = dataSets;
                    });
                } else {
                    $scope.dataSets = [];
                }
            }
        });
    }])
;